import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

import { ApiErrorFactory } from './../../../../core/api-errors';
import { CacheService } from './../../../../core/cache/cache.service';
import { PhpVersionService } from './../../../../core/php-version';
import { ErrorDialog } from './../../../../views/dialog';
import { SpeedScoreService } from './../../../../views/home';
import { parseWpVersion, getRequiredWpForPhp, isWpLowerThanRequirement } from '../../../../core/php-version-compat';
@Component({
  selector: 'app-php-version-change',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './php-version-staging-change.component.html',
  styleUrls: ['./php-version-staging-change.component.scss'],
  standalone: false,
})
export class PhpVersionStagingChangeComponent implements OnInit {
  private wpMajor = 0;
  private wpMinor = 0;
  is_accept = false;
  warn = false;
  warnMessageKey: string | null = null;
  warnMessageParams: { [key: string]: string } | null = null;
  private errorDialogRef: MatDialogRef<ErrorDialog>;
  public currentPhpVersion;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private phpVersionService: PhpVersionService,
    public dialogRef: MatDialogRef<PhpVersionStagingChangeComponent>,
    private translate: TranslateService,
    private cacheService: CacheService,
    private speedScoreService: SpeedScoreService,
    private apiErrorFactory: ApiErrorFactory,
    private alertService: SnackbarService,
  ) {}
  form = new FormGroup({
    php_version: new FormControl('', Validators.required),
  });

  ngOnInit(): void {
    const php_version = this.data.php_version;
    const current_wp_version = this.data.wp_version;
    if (current_wp_version != null) {
      const { major, minor } = parseWpVersion(current_wp_version);
      this.wpMajor = major;
      this.wpMinor = minor;
    }
    this.currentPhpVersion = php_version;
    this.form.setValue({
      php_version: php_version,
    });
  }

  checkValidation(e) {
    const new_php_version = e.target.value;
    const requiredWp = getRequiredWpForPhp(new_php_version);
    if (requiredWp) {
      if (isWpLowerThanRequirement(this.wpMajor, this.wpMinor, requiredWp)) {
        this.is_accept = false;
        this.warn = true;
        this.warnMessageKey = 'PAGES.CHANGE_PHP_VERSION.WARNING_GENERIC';
        this.warnMessageParams = {
          php: String(new_php_version),
          wp: `${requiredWp[0]}.${requiredWp[1]}`,
        };
        return;
      }
    }
    if (this.currentPhpVersion == new_php_version) {
      this.is_accept = false;
      return;
    }
    this.is_accept = true;
    this.warn = false;
    this.warnMessageKey = null;
    this.warnMessageParams = null;
  }

  changePhpVersion() {
    if (this.is_accept) {
      this.phpVersionService.setPhpVersionStaging(this.form.value.php_version);
      this.cacheService.flushCache().subscribe(
        () => this.closeDialog(),
        (err) => this.handleError(err),
      );
      this.speedScoreService.clear_cache();
    }

    this.closeDialog();
    this.currentPhpVersion = this.form.value.php_version;
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  handleError(errorResponse: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactory.parseErrorResponse(errorResponse);
    this.alertService.openErrorSnack(parsedError.getUserMessage(), this.translate.instant('ALERTS.GENERAL.DISMISS'));
  }
}
